export class ClaimModel {
    id: string | undefined;
    code: string | undefined;
    description: string | undefined;
    isChecked: boolean | undefined;
}